import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = {
  style: {"width":"20%"},
  rowspan: "3",
  class: "align-middle"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0"
}
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["alt", "src"]
const _hoisted_15 = {
  class: "modal fade",
  id: "create-task",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = { class: "modal-body px-4" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 2,
  class: "download-container"
}
const _hoisted_22 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Détails du usager", -1)),
            _createVNode(_component_router_link, {
              to: "/liste-usager",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_7, [
                  (_ctx.imagePreview)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFile(_ctx.imagePreview)))
                      }, [
                        _createElementVNode("img", {
                          style: {"height":"134px"},
                          src: _ctx.imagePreview,
                          class: "img-thumbnail",
                          alt: "Image preview"
                        }, null, 8, _hoisted_8)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("div", null, [
                          _createElementVNode("i", { class: "flaticon-camera fs-1" })
                        ], -1)
                      ]))]))
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "Nom:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.usager?.nom), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "Prenom:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.usager?.prenom), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "Sexe:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.usager?.sexe), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "Email:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString((_ctx.usager && _ctx.usager.email) ? _ctx.usager.email : "Aucun email renseigné"), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "Numéro de téléphone:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString((_ctx.usager && _ctx.usager.tel) ? _ctx.usager.tel : "Aucun numéro de téléphone renseigné"), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "NPI:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString((_ctx.usager && _ctx.usager.npi) ? _ctx.usager.npi : "Aucun npi renseigné"), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "IFU:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString((_ctx.usager && _ctx.usager.ifu) ? _ctx.usager.ifu : "Aucun ifu renseigné"), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.autreFichiers.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autreFichiers, (media, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    type: "button",
                    onClick: ($event: any) => (_ctx.openFile(media.url))
                  }, [
                    _createElementVNode("img", {
                      style: {"width":"200px","height":"200px"},
                      alt: 'Autre Media' + index,
                      class: "rounded",
                      src: media.url
                    }, null, 8, _hoisted_14)
                  ], 8, _hoisted_13))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h6", { class: "modal-title" }, "Fichier"),
            _createElementVNode("button", {
              type: "button",
              id: "close-modal",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.isImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.fileUrl,
                  alt: "Aperçu",
                  class: "preview-image"
                }, null, 8, _hoisted_19))
              : (_ctx.isPdf)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 1,
                    src: _ctx.fileUrl,
                    class: "preview-iframe"
                  }, null, 8, _hoisted_20))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("img", {
                      src: _ctx.fileUrl,
                      class: "rounded mx-auto d-block",
                      alt: "..."
                    }, null, 8, _hoisted_22)
                  ]))
          ])
        ])
      ])
    ])
  ]))
}